class EventGroup {
	constructor(groupId){
		this._id = groupId || 0;
		this._events = [];

		this.targetLayer = null
		this.moveTime = null;
		this.repeatData = null;
		this.saveAction = null;
	}

	get id() {
		return this._id;
	}
	set id(value) {
		this._id = value;
	}
	getEventIds() {
		// returns a simple array of eventIds
		let ids = [];
		for (let i = 0, ii = this._events.length; i < ii; i++) {
			ids.push(this._events[i].id);
		}
		return ids;
	}
	getOtherGroupIds() {
		// returns an array of unique event groupId - used to find existing groups before creating new ones
		let ids = [];
		for (let i = 0; i < this._events.length; i++) {
			if (!this._events[i].groupId) continue;
			ids.push(this._events[i].groupId);
		}
		if (ids.length === 0 || (ids.length === 1 && ids[0] === this.id)) return false;
		return [... new Set(ids)];
	}
	initGroupBar(handle) {
		handle.innerHTML = '';
		for (let i = 0; i < this._events.length; i++) {
			handle.appendChild(div('group-handle-point'));
		}
	}
	updateGroupBar(handle, timeline){
		let tl = timeline || globalTimeline;
		let left = tl.timeToOffset(this.firstEvent.dynamicStartTime);
		let width = tl.timeToOffset(this.lastEvent.dynamicEndTime) - left;
		handle.style.left = left + 'px';
		handle.style.width = width + 'px';
		let i = 0;
		for (let c = handle.firstChild; c !== null; c = c.nextSibling) {
			c.style.left = tl.timeToOffset(this._events[i++].center) - left + 'px';
		}
	}
	addEvent(obj) {
		if (this._events.indexOf(obj) === -1) {
			this._events.push(obj);
		}
	}
	remEvent(event) {
		let i = this._events.indexOf(event);
		if (i !== -1) {
			this._events.splice(i, 1);
			event.selected = false;
		}
	}
	addRemove(tlEvent) {
		let i = this._events.indexOf(tlEvent);
		if (i === -1) {
			this._events.push(tlEvent);
			tlEvent.activeInstance.selected = true;
		} else {
			this._events.splice(i, 1);
			tlEvent.activeInstance.selected = false;
		}
	}
	select (selection) {
		this._events.forEach(function(event) {
			selection.addRemove(event)
		});
	}
	count() {
		return this._events.length;
	}
	/* clear() {
		this._events.forEach(function(f) {
			f.selected = false;
		})
		if (!this._id) this._events = [];
		// globalTimeline.setActiveGroup(null);
	} */
	delete(manager) {
		this.manager = manager;
		this.saveAction = "deleteEvents";
		this.save();
	}
	sort() {
		if (this._events.length === 0) return false;
		this._events.sort(function (a, b) {
			return parseInt(a.startTime) - parseInt(b.startTime)
		});
		for (var i = 0; i < this._events.length; i++) {
			this._events[i].offsetFrom(this._events[0].startTime);
		}
		return this.firstEvent;
	}
	get firstEvent() {
		return this._events[0];
	}
	get lastEvent() {
		return this._events[this._events.length - 1];
	}
	set selected(value) {
		this._events.forEach(function (event) {event.selected = value});
	}
	prepMove(layer) {
		this.targetLayer = layer;
		// prep each event for moving -> ignore events other events in this group
		this.sort();
		//this.cursorTime = globalTimeline.cursorToUtc(ev, SNAP_DISTANCE);
		this._events.forEach(function(event) {event.moving = true;});
		for (let i = 0, ii = this._events.length; i < ii; i++) {
			this._events[i].prepMove(TIMELINE_EVENT.MOVE_EVENT);
		}
	}
	move() {
		let tl = globalTimeline.activeLayer?.activeView?.timeline || globalTimeline;
		let moveTime = tl.pixelsToMilliseconds(dx, SNAP_DISTANCE);
		let overlapValues = [];
		this._events.forEach(function(event) {
			overlapValues = overlapValues.concat(event.getOverlapValues(moveTime, moveTime));
		})
		overlapValues.sort(function (a, b) {return Math.abs(a) - Math.abs(b)});

		// find smallest overlap adjustment that returns no overlap from all events
		let limitAdjustment = 0;
		limitLoop:
		for (let a = 0, aa = overlapValues.length; a < aa; a++) {
			limitAdjustment = overlapValues[a];
			for (let b = 0, bb = this._events.length; b < bb; b++) {
				let checkAdjustments = this._events[b].getOverlapValues(moveTime + limitAdjustment);
				checkAdjustments.sort(function (a, b) {return Math.abs(a) - Math.abs(b)});
				if (checkAdjustments[0] !== 0) continue limitLoop;
			}
			// moveTime -= limitAdjustment;
			break;
		}
		this.moveTime = moveTime + limitAdjustment;
		this._events.forEach(function(event) {
			event.setOffset(this.moveTime);
			event.update();
		}, this);
		globalTimeline.update();
	}
	moveToTime(value) {
		this.moveTime = this.calcMoveTime(value);
	}
	calcMoveTime (value) {
		return value - this.firstEvent.startTime;
	}
	completeDragMove() {
		this.moving = false;
		this._events.forEach(function(event){
			event.applyMove();
			event.relocate();
		});
		this.save();
	}
	unGroup() {
		this.saveAction = 'delete';
		this.save();
	}
	giveIds() {
		for (let i = 0, ii = this._events.length; i < ii; i++) {
			this._events[i]._groupId = this._id;
			this._events[i].updateView();
			this._events[i].draw();
		}
	}
	setEventGroupIds(id) {
		id = typeof id === 'undefined' ? this._id : id;
		for (let i = 0; i < this._events.length; i++) {
			this._events[i]._groupId = id;
			this._events[i].update();
		}
	}
	make() {
		this.saveAction = 'make';
		this.save();
	}
	repeat() {
		this.saveAction = 'repeat';
		this.targetLayer = this.firstEvent.layer;
		this.save();
	}
	save(splitOption) {
		if (!!this.firstEvent.repeatId && typeof splitOption === 'undefined') {
			// get repeat option
			globalTimeline.getSplitOptions(this);
			// splitRepeatDialog.open();
			return;
		}
		this.splitOption = splitOption || 1;
		saveManager.queue(this);
	}
	saveNow() {
		let post = {'action': this.saveAction};

		if (this._id) {
			post.id = this._id;
			if (this._events.length < 2) {
				post.action = 'delete';
			}
		}
		else if (1 < this._events.length) {
			post.eventIds = this.getEventIds();
		}
		else {
			saveManager.nudge();
			return
		}

		switch (this.saveAction) {
			case 'repeat': // repeat the group
				post.repeatData = this.repeatData;
				break;
			default:
				post.moveTime = this.moveTime / 1000;
		}
		if (!this.targetLayer) {
			this.targetLayer = this.firstEvent.layer;
		}
		post.layerId = this.targetLayer.id;
		post.splitOption = this.splitOption || 1;
		post.timeA = globalTimeline.memoryTimeA / 1000;
		post.timeB = globalTimeline.memoryTimeB / 1000;


		ajp('event-group/save', post, null, this.saveCallback, this);
		this.saveAction = null;
	}
	saveCallback(reply) {
		saveManager.nudge();
		this.splitOption = null;
		this.sort();


		// distribute the group id returned by server
		if (reply.groupId) {
			this._id = reply.groupId;
			this.targetLayer.groups.add(this);
			this._events.forEach(function(te) {
					te._groupId = this._id;
					// te.selected = !this._id;
					te.update();
			},this);
			globalTimeline.clearSelection();
			globalTimeline.selectEvent(this.firstEvent);
			// this.targetLayer.manager.selectEvent(this.targetLayer.getEventById(activeEventId));
			// globalTimeline.updateControls();
			return;
		}

		let activeEventId = globalTimeline.activeEvent !== null ? globalTimeline.activeEvent.id : 0;
		let sourceLayer = this.firstEvent.layer;

		if (reply.changedRepeatIds && Array.isArray(reply.changedRepeatIds)) {
			reply.changedRepeatIds.forEach(function (data) {
				let event = sourceLayer.getEventById(data[0]);
				if (event) {
					event.repeatId = data[1];
					event.applyChanges();
				}
			},this);
		}

		if (reply.removed && Array.isArray(reply.removed)) {
			reply.removed.forEach(function (data) {
				sourceLayer.removeEventById(data);
			}, this);
		}

		if (reply.deleteGroup) {
			for (let i = 0, ii = this._events.length; i < ii; i++) {
				this._events[i].groupId = 0;
			}
			sourceLayer.groups.remove(this);
			return;
		}

		if (sourceLayer.id != this.targetLayer.id) {
			sourceLayer.groups.remove(this);
			this.targetLayer.groups.add(this);
		}

		if (reply.added && Array.isArray(reply.added)) {
			this.targetLayer.loadEvents(reply.added);
		}

		// this.targetLayer.manager.selectEvent(this.firstEvent);

		this.targetLayer.manager.selectEvent(this.targetLayer.getEventById(activeEventId));
	}
}
